<template>
  <div class="admin">
    <div v-if="this.isAdmin === true" id="hidden-content">

      <!-- Navbar content -->
      <!-- <nav class="navbar red">
        <router-link to="/admin" class="navbar-brand">Admin Panel</router-link>
        <span id="profile-name">{{ email }}  &nbsp; <button v-on:click="logout">Logout</button></span>

      </nav> -->

      <!-- Main content -->
      <div class="main-content">
        <router-view/>
      </div>
    </div>
    <div v-if="this.isAdmin === false">
      <br>
      You are not permitted to access Admin panel. <br>
      <router-link to="/" class="navbar-brand">Return to Dashboard</router-link>
    </div>
  </div>

</template>

<script>
  import firebase from 'firebase'
  import db from '../main.js'
  import {store} from '../store/store.js'
  import Vuex from 'vuex'

  export default {
    name: 'profile',
    data: function() {
      return {
        id: firebase.auth().currentUser.uid,
        firstName: null,
        lastName: null,
        email: null,
        isAdmin: null,
        company: null
      }
    },
    mounted() {
      db.collection('users').where('id', '==', this.id).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          console.log(doc.id, ' => ', doc.data())
          this.firstName = doc.data().firstName,
          this.lastName = doc.data().lastName,
          this.email = doc.data().email,
          this.isAdmin = doc.data().isAdmin,
          this.company = doc.data().title
        })
      })
    },
    methods: {
      logout: function() {
        firebase.auth().signOut().then(() => {
          this.$store.dispatch('setUser')
          this.$router.replace('login')
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  button {
    margin: 0;
  }
  .admin {
    width: 100%;
  }
</style>
